import React from "react";
import isEmpty from "lodash/isEmpty";
import Associative from "../associative";
import { getValueWarp, getPageSize } from "../../wea-browser/coms/util";
import { initialState } from "./propType";

export function focus() {
  this.associative && this.associative.focus && this.associative.focus();
}

export function onCustomClick(e) {
  const { onBeforeFocusCheck } = this.props;
  e && e.preventDefault();
  if (onBeforeFocusCheck) {
    let cb = this.onCustomClickInner.bind(this);
    onBeforeFocusCheck(cb);
  } else {
    this.onCustomClickInner(e);
  }
}

export function onCustomClickInner(e) {
  const { memorise } = this.props;
  if (memorise) {
    const { idCache, nameCache } = this.state;
    this.onBrowerClick(
      idCache ? [{ id: idCache, name: nameCache }] : undefined
    );
  } else {
    this.onBrowerClick();
  }
}

export function onBrowerClick(v, openModal = true) {
  const { onBrowerClick } = this.props;
  if (onBrowerClick) {
    onBrowerClick(v, () => {
      this.onBrowerClickInner(v, openModal);
    });
  } else {
    this.onBrowerClickInner(v, openModal);
  }
}

export function onBrowerClickInner(v, openModal) {
  const {
    isSingle,
    hasAdvanceSerach,
    hideAdvanceSearch,
    pageSize,
    hasLeftTree
  } = this.props;
  this.setState({
    ...initialState,
    visible: openModal,
    pageSize: pageSize > 0 ? pageSize : getPageSize(this.props)
  });
  const cb = () => {
    // this.setState({ visible: openModal });
    if (!isSingle) {
      this.getSelectedData(v);
    } else {
      if (!isEmpty(v)) {
        this.setState({ idCache: v[0].id, nameCache: v[0].name });
      } else {
        this.setState({ idCache: "", nameCache: "" });
      }
    }
    this.getTabsFromUrl(() => {
      this.onSearch({}, this.getDefaultActiveKey());
    });
  };
  if (
    (isSingle && (hasAdvanceSerach || this.isCrm())) ||
    (!isSingle && !hideAdvanceSearch)
  ) {
    this.getConditions(cb);
  } else {
    cb();
  }
  if (isSingle && hasLeftTree) {
    this.getLeftTreeDatas();
  }
}

export function getAssociative() {
  const { inputStyle, fieldName, customized, children } = this.props;
  if (customized) {
    return (
      <div className="cursor-pointer" onClick={this.onCustomClick}>
        {children}
      </div>
    );
  }
  const { data } = this.state;
  const ids = data.map(item => item.id || "");
  const inputHidden = (
    <input
      type="hidden"
      id={fieldName}
      name={fieldName}
      value={ids.join(",")}
    />
  );
  const props = {
    ...this.props,
    valueWarp: getValueWarp(this.props),
    style: inputStyle,
    data,
    value: ids,
    ref: el => (this.associative = el),
    onChange: v => this.setState({ selectedData: v }, () => this.onChange(v)),
    appendSearchValues: this.appendSearchValues,
    clickCallback: this.onBrowerClick
  };
  return [<Associative {...props} />, inputHidden];
}



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/browser/getAssociative.js